var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegisteredPlanIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 5.33301H23.9997C24.7069 5.33301 25.3852 5.61396 25.8853 6.11406C26.3854 6.61415 26.6663 7.29243 26.6663 7.99967V26.6663C26.6663 27.3736 26.3854 28.0519 25.8853 28.552C25.3852 29.0521 24.7069 29.333 23.9997 29.333H7.99967C7.29243 29.333 6.61415 29.0521 6.11406 28.552C5.61396 28.0519 5.33301 27.3736 5.33301 26.6663V7.99967C5.33301 7.29243 5.61396 6.61415 6.11406 6.11406C6.61415 5.61396 7.29243 5.33301 7.99967 5.33301H10.6663",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 2.66699H12.0003C11.2639 2.66699 10.667 3.26395 10.667 4.00033V6.66699C10.667 7.40337 11.2639 8.00033 12.0003 8.00033H20.0003C20.7367 8.00033 21.3337 7.40337 21.3337 6.66699V4.00033C21.3337 3.26395 20.7367 2.66699 20.0003 2.66699Z",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14L14.7775 21.2778L10.333 16.8333",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisteredPlanIconWhite);
export default __webpack_public_path__ + "static/media/registered_plan_icon_white.8ce06941d66f37ad8e232b55ec7d9ad3.svg";
export { ForwardRef as ReactComponent };